export const VERIFY_FBM_INSTALL = ['verifyFbmInstall'];
export const REQUEST_STATUS = ['requestStatus'];
export const PAGE_CONFIG = ['config'];
export const PAGE_NAME = ['messengerChannel', 'pageName'];
export const PAGE_LINK = ['messengerChannel', 'profileUrl'];